/**
 * Modal de Notificação Reutilizável
 * Substitui o alert() nativo por um modal elegante.
 *
 * Uso:
 *   window.showNotificationModal({
 *     title: 'Ops!',
 *     message: 'Algo deu errado.',
 *     type: 'error'   // 'error' | 'success' | 'info'
 *   });
 */

(function () {
  'use strict';

  const modal = document.getElementById('modal-notification');
  const titleEl = document.getElementById('modal-notification-title');
  const messageEl = document.getElementById('modal-notification-message');
  const iconEl = document.getElementById('modal-notification-icon');
  const headerEl = document.getElementById('modal-notification-header');

  const TYPE_STYLES = {
    error: {
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      iconPath: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    },
    success: {
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      iconPath: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    },
    info: {
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      iconPath: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    },
  };

  function updateIcon(type) {
    const style = TYPE_STYLES[type] || TYPE_STYLES.info;
    iconEl.className = `flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${style.iconBg} ${style.iconColor}`;
    iconEl.querySelector('svg path').setAttribute('d', style.iconPath);
  }

  function openModal() {
    if (!modal) return;
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    // Foco no botão OK para acessibilidade
    const okBtn = modal.querySelector('button[onclick="window.closeNotificationModal()"]');
    if (okBtn) okBtn.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  function showNotificationModal(options) {
    if (!modal) {
      console.warn('[ModalNotification] Modal element not found. Falling back to alert.');
      alert(options.message || options.title || '');
      return;
    }

    const opts = typeof options === 'string' ? { message: options, title: 'Aviso', type: 'info' } : options;

    const type = opts.type || 'info';
    const title = opts.title || 'Aviso';
    const message = opts.message || '';

    if (titleEl) titleEl.textContent = title;
    if (messageEl) messageEl.textContent = message;

    updateIcon(type);
    openModal();
  }

  // Fecha com Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });

  // Expor globalmente
  window.showNotificationModal = showNotificationModal;
  window.closeNotificationModal = closeModal;
})();
